<template>
    <div class="container-body-pallete">
        <ul class="ul-body-pallete-list">
            <li
                v-for="(pallete, index) in body_pallete_list"
                :key="index"
                class="li-body-pallete btn btn-outline-primary btn-sm"
                :class="{ 'active': pallete.id == $store.state.character.bodyPalette }"
                :id="pallete.id"
                @click="clickBodyPallete($event)"
            >
                {{ pallete.id }}
            </li>
        </ul>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'BodyPallet',
    data() {
        return {
            body_pallete_list: [
                { id: 0, name: 'regular' },
                { id: 1, name: 'blue' },
                { id: 2, name: 'red' },
                { id: 3, name: 'green' },
            ],
        }
    }, methods: {
        ...mapMutations(['SAVE_BODY_PALETTE']),
        clickBodyPallete: function (event) {
            this.SAVE_BODY_PALETTE(parseInt(event.target.getAttribute('id')))
        }
    }
}
</script>

<style scoped>
.container-body-pallete {
    display: inline-block;
}
.ul-body-pallete-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 4px;
}
.li-body-pallete {
    padding: 2px 8px;
    min-width: 32px;
}
</style>
